import { apiConstants } from '../../apiConstant'
import { serviceCall, serviceCallAuth } from '../../serviceCall'

export const addressByPlaceId = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCallAuth({
      url: apiConstants.AUTH.ADDRESS_BY_PLACE_ID,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
